import { render } from "./notification-panel.vue?vue&type=template&id=0f99b040"
import script from "./notification-panel.vue?vue&type=script&lang=js"
export * from "./notification-panel.vue?vue&type=script&lang=js"

import "./notification-panel.vue?vue&type=style&index=0&id=0f99b040&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__